<template>
    <b-row >   
        <b-col class="ml-15 p-0">
            <label for="isdefV">Ответ по умолчанию</label>
            <yes-no-input id="isdefV"
                          :key="localDisplayCondition" 
                          v-model="isDefaultValue"
                          class="mt-0"
                          @click="setIsDefault"/>
        </b-col>
        
        <template v-if="isDefaultValue" >
            <b-col cols="8" 
                class="m-0 p-0" 
                v-if="localDisplayCondition==1 || localDisplayCondition==10 ||
                        localDisplayCondition==11 || localDisplayCondition==12 || 
                        localDisplayCondition==20 || localDisplayCondition==22" >

                <label for="defV">Значение</label>                
                <b-input v-if="localDisplayCondition==1"
                        id="defV" 
                        v-model="defaultValue" 
                        @input="setValue"/>

                <b-input v-if="localDisplayCondition==10"
                        id="defV" 
                        v-model="defaultValue" 
                        type="number"
                        @input="setValue" />

                <b-input v-if="localDisplayCondition==11"
                        id="defV" 
                        v-model="defaultValue" 
                        type="number"
                        step="0.1"
                        @input="setValue" />

                <b-input v-if="localDisplayCondition==12" 
                        id="defV" 
                        v-model="defaultValue" 
                        type="number"
                        min="0"
                        max="100"
                        @input="setValue"/>

                <custom-multiselect v-if="localDisplayCondition==20 || 
                                            localDisplayCondition==22"
                                    
                                    id="defV"
                                    v-model="defaultValue"
                                    :options="localAnswerOptions"
                                    @select="setValue"/>
                
            </b-col>

        </template>
    </b-row>
</template>

<script>

import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'

export default {
    model: {
            prop: 'value',
            event: 'update'
    },
    props: {
        value: {
            type: [Boolean, String, Number],
            default: false
        }, 
        displayCondition: {
            type: Number,
            default: 0
        },
        answerOptions: {
            type: [Object, Array],
            default: null
        }
    },
    computed: {
        defaultValue: {
            get: function() {                  
                return (this.displayCondition == 20 || this.displayCondition == 22) 
                            ? this.localAnswerOptions.filter(e => e.Id == this.value)
                            : this.value;
            },
            set: function(value) {
                return value;
            }
        },
        localDisplayCondition: function() {
            if(this.displayCondition == 21 || this.displayCondition == 40 || this.displayCondition > 100)
                this.$emit('update', this.isDefaultValue);

            return this.displayCondition;
        },
        localAnswerOptions: function() {
            return this.answerOptions.filter(e => e.Id);
        }
    },
    data: function() {
        let isYesNoType = this.displayCondition == 21 || this.displayCondition == 40 || this.displayCondition > 100;
        let isValueNull = this.value == null;
        let defaultValue = null;

        if(!isValueNull && isYesNoType) {
            defaultValue = this.value == "true" || this.value == true ? true : false;
        }
        else { 
                if(!isYesNoType) 
                    defaultValue = this.value ? true : false;
        }

        return {
            isDefaultValue: defaultValue
        }
    },
    methods: {
        setIsDefault: function(value) {
            if(this.displayCondition == 21 || this.displayCondition == 40 || this.displayCondition > 100) {
                this.$emit('update', value);
            }
            else {
                if(!value) 
                    this.$emit('update', null);                                        
            }
        },
        setValue: function(value) {
            if(!value) {
                this.$emit('update', value);
                return;
            }                   

            this.displayCondition == 20 || this.displayCondition == 22
                ? this.$emit('update', value.Id)
                : this.$emit('update', value);
        }
    },
    components: {
        YesNoInput,
        CustomMultiselect
    }

}
</script>